import type { ApiResponse } from '@/models/api'
import { api, readData } from '@/services/apiClient'

export interface CrmAccount {
  id: string
  name: string
  useGridReferences?: boolean
  useDeliveryDay?: boolean
  useCallDay?: boolean
  onboardingCompleted?: boolean
  onboardingStep?: number
  emailAddress: string | null
  phone: string | null
  address1: string | null
  address2: string | null
  address3: string | null
  city: string | null
  county: string | null
  postcode: string | null
  countryCode: string | null
  vatRegistered: boolean
  vatNumber: string | null
  limitedCompany: boolean
  limitedCompanyNumber: string | null
  paymentTerm: number
}

export interface CrmAccountInput {
  name: string
  useGridReferences?: boolean
  useDeliveryDay?: boolean
  useCallDay?: boolean
  emailAddress: string | null
  phone: string | null
  address1: string | null
  address2: string | null
  address3: string | null
  city: string | null
  county: string | null
  postcode: string | null
  countryCode: string | null
  vatRegistered: boolean
  vatNumber: string | null
  limitedCompany: boolean
  limitedCompanyNumber: string | null
  paymentTerm: number
}

export async function loadCrmAccount(): Promise<CrmAccount> {
  const { data } = await api.get<ApiResponse<CrmAccount>>('/account')
  return readData(data, {
    id: '',
    name: '',
    emailAddress: null,
    phone: null,
    address1: null,
    address2: null,
    address3: null,
    city: null,
    county: null,
    postcode: null,
    countryCode: null,
    vatRegistered: false,
    vatNumber: null,
    limitedCompany: false,
    limitedCompanyNumber: null,
    paymentTerm: 0,
  })
}

export async function saveCrmAccount(input: CrmAccountInput): Promise<void> {
  const { data } = await api.put<ApiResponse<null>>('/account', input)
  readData(data, null)
}
